// extracted by mini-css-extract-plugin
export default {"GateBody":"skipEvent_GateBody__-rdY6","Counter":"skipEvent_Counter__Ec3h7"};